module.exports = "data:image/png;base64,UklGRmgBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSJ0AAAABh8GwbSTFwZsd2HvGiIjB7j7yL02aIFFM6ZKpNUZjYcDlIOjaS3AY2bbSXNzdHaI4r//2PnlpIaL/EwC/xZ815ZbFkgeilCXVRBFLzoeXxQKQzvOyruv21m4c+r1JwsggRYgZhySgOs9z3/f9qwOQguZRhJnneZ5rq4CUEvV5eW8CiOiakiRJwjC0VcCgT/s0wVS7Jgt1DlRTgcQAAFZQOCCkAAAAcAIAnQEqEAAQAAIANCWwAnQGKtW0qq5Cm73g2AD+2Hywpu6PemdN8/m3lUOJhm9VtKzvMmrPIluMUAQZa/YUZShcxDgfEKBVwDL92PtQOH+KPv/hUKhyHlzVgjnVcNWr9/Lmz/5q+KeIr32d4af5Evj3cqfZnIel0YOXOvg4StidQW/K3VpYri3q11j48NfBX5htsJsd2kp1Z7TL5VmoWfPgAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes_icons/icon_Blueprint_MakeStruct_16x.png
// module id = 37
// module chunks = 0